import React from 'react';
import Page from './pages'

function App() {
  return (
    <Page />
  );
}

export default App;
